module.exports = __webpack_public_path__ + "static/img/manual_zh_18.a2ce518.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_18.png
// module id = +5si
// module chunks = 4